(function($, undefined) {
	
	'use strict';
	var popupTriggerBtns;
	var popupCloseBtn;
	var popupCancelBtn;
	
	var closeThisPopup = function() {
		var element = $(this).hasClass('popup-outer') ? $(this) : $(this).closest('.popup-outer');
		element.removeClass('visible');
	};
	
	var openPopupByTrigger = function() {
		var btn = $(this);
		openPopupById(btn.attr('data-popup-id'));
	};
	
	var openPopupById = function(id) {
		var popup = $('.popup-outer#' + id);
		popup.addClass('visible');	
	};
	
	var closePopupById = function(id) {
		var popup = $('.popup-outer#' + id);
		popup.removeClass('visible');	
	};
	
	var stopPropagation = function(e) {
		e.stopPropagation();
	};
	
	var init = function () {
		popupTriggerBtns = $('.popup-toggle-btn');
		popupCloseBtn = $('.popup-close-btn');
		popupCancelBtn = $('.popup-outer .cancel-btn');
		
		popupTriggerBtns.on('click', openPopupByTrigger);
		popupCloseBtn.on('click', closeThisPopup);
		popupCancelBtn.on('click', closeThisPopup);
		
		$('.popup-outer').on('click', closeThisPopup);
		$('.popup-inner').on('click', stopPropagation);
	};
	
	$(window).ready(function () {
		init();
	});
	
	var popup = Fw.component.export('popup', {
		openPopupById: openPopupById,
		closePopupById: closePopupById
	});
	
})(jQuery);
